// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2zY1j","content":"styles_content__2d07G","selectAll":"styles_selectAll__yvSz9"};